import React from 'react';
import AchGadolPageShell from '../components/AchGadolPageShell';
import AchGadolStatic from './AchGadolStatic';

export default function AchGadol() {
  return (
    <AchGadolPageShell
      strapiApiId="page-ach-gadol"
      defaultTitle="Ach Gadol"
      defaultDonationLine="Pour soutenir les soldats seuls via l'association Ach Gadol, cliquez ICI"
      StaticFallback={AchGadolStatic}
    />
  );
}
